module.exports = __webpack_public_path__ + "static/media/player4.72f4e03d.png";